module.exports = __webpack_public_path__ + "img/42.981f8446.jpg";